<template>
  <generic-modal
    size="large"
    :title="$t('student portal module configuration')"
    icon="settings"
    image="/images/icons/student.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="finished"
    :show_ok="true"
    :show_cancel="true"
  >
    <div class="description">
      <div class="ui two item top attached tabular menu">
        <a class="active item" data-tab="general">
          <i class="info icon"></i>
          {{ $t("general info") }}</a
        >
        <a class="item" data-tab="mail">
          <i class="code icon"></i>
          {{ $t("password recovery template") }}</a
        >
      </div>
      <div class="ui bottom attached active tab segment" data-tab="general">
        <div class="ui form">
          <h5 class="ui dividing header">
            {{ $t("password recovery settings") }}
          </h5>
          <div class="two fields">
            <div class="field">
              <label for>{{ $t("expire time") }}</label>
              <input
                type="text"
                name="expire_time"
                v-model="setup.expire_time"
              />
            </div>
            <div class="field">
              <label for>{{ $t("expire time unit") }}</label>
              <select
                class="ui selection dropdown"
                ref="expire_unit_dropdown"
                name="expire_unit_type"
                v-model="setup.expire_time_unit"
              >
                <option value="h">{{ $t("hour") }}</option>
                <option value="d">{{ $t("day") }}</option>
                <option value="M">{{ $t("month") }}</option>
              </select>
            </div>
          </div>
          <div class="two fields">
            <div class="field">
              <label for>{{ $t("email subject") }}</label>
              <input
                type="text"
                name="email_subject"
                v-model="setup.email_subject"
              />
            </div>
            <div class="field">
              <label for>{{ $t("email gateway") }}</label>
              <div
                class="ui search selection dropdown"
                ref="email_gateway_dropdown"
              >
                <input type="hidden" name="email_gateway" />
                <i class="dropdown icon"></i>
                <div class="default text">{{ $t("email gateway") }}</div>
              </div>
            </div>
          </div>
          <h5 class="ui dividing header">
            {{ $t("appeareance settings") }}
          </h5>
          <div class="fields">
            <div class="six wide field">
              <label for>{{ $t("username field name") }}</label>
              <input
                type="text"
                name="username_field_name"
                v-model="setup.username_field_name"
              />
            </div>
            <div class="six wide field">
              <label for>{{ $t("logo") }}</label>
              <file-uploader
                name="file"
                url="/student_portal/student_portal/do-upload-logo"
                @error="error_uploading"
                @uploaded="end_uploading"
              />
            </div>
            <div
              class="four wide field"
              v-if="setup.logo && setup.logo.relative_path"
            >
              <img
                class="ui image"
                :src="api_host + '/' + setup.logo.relative_path"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="ui bottom attached tab segment" data-tab="mail">
        <div class="ui info message" style="display: block">
          <div class="header">{{ $t("hints") }}</div>
          <ul class="list">
            <li v-html="$t('use ${student.name} to refer student name')"></li>
            <li
              v-html="$t('use ${student.id_card} to refer student card id')"
            ></li>
            <li
              v-html="$t('use ${student.url} to refer recover link url')"
            ></li>
          </ul>
        </div>
        <wysywyg v-model="setup.mail" :show_js="false" :show_css="false" />
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, error_toast, api_host } from "@/utils";
import GenericModal from "@/components/GenericModal";
import Wysywyg from "@/components/Wysywyg/Wysywyg";
import FileUploader from "@/components/FileUploader.vue";
// import DocumentTypes from "./DocumentTypes.vue";

export default {
  name: "StudentPortalConfigureModal",
  components: {
    "generic-modal": GenericModal,
    FileUploader,
    Wysywyg,
  },
  computed: {},
  data() {
    return {
      setup: {
        expire_time: "",
        expire_time_unit: "",
        email_gateway: "",
        email_subject: "",
        mail: {},
        username_field_name: "",
        logo: "",
      },
      api_host: api_host,
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        local_api(
          vm,
          "post",
          "/student_portal/student_portal/do-save-configuration",
          {
            s: vm.setup,
          },
        )
          .then(() => {
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    error_uploading(err) {
      console.error(err);
    },
    end_uploading(file) {
      let vm = this;
      vm.setup.logo = file;
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/student_portal/student_portal/do-get-configuration")
      .then((conf) => {
        if (conf && conf.gateways) {
          let vls = conf.gateways.map((gw) => {
            return { name: gw.name, value: gw.messaging_id };
          });
          window
            .jQuery(vm.$refs.email_gateway_dropdown)
            .dropdown("setup menu", { values: vls })
            .dropdown({
              onChange(value) {
                vm.setup.email_gateway = value;
              },
            });
        }

        if (conf && conf.configuration) {
          vm.setup.expire_time = conf.configuration.expire_time;
          vm.setup.expire_time_unit = conf.configuration.expire_time_unit;
          if (conf.configuration.email_gateway) {
            setTimeout(() => {
              window
                .jQuery(vm.$refs.email_gateway_dropdown)
                .dropdown("set selected", conf.configuration.email_gateway);
            }, 500);
          }
          vm.setup.email_gateway = conf.configuration.email_gateway;
          vm.setup.email_subject = conf.configuration.email_subject;
          vm.setup.mail = conf.configuration.mail;
          vm.setup.username_field_name = conf.configuration.username_field_name;
          vm.setup.logo = conf.configuration.logo;
          setTimeout(() => {
            window.jQuery(vm.$refs.expire_unit_dropdown).dropdown();
          }, 200);
        }
      })
      .catch((err) => {
        error_toast(err);
      });

    window.jQuery(".ui.menu .item").tab();
  },
  watch: {},
  updated: function() {},
};
</script>
